import { render, staticRenderFns } from "./InputCatcher.vue?vue&type=template&id=54a6f78a&scoped=true"
import script from "./InputCatcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputCatcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputCatcher.vue?vue&type=style&index=0&id=54a6f78a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6f78a",
  null
  
)

export default component.exports